import Badge from '../../common/component/Badge';

interface IProps {
  className?: string;
  blackBadgeList?: string[];
}

export default function BlackBadgeListV4({className, blackBadgeList}: IProps) {
  return (
    <>
      {blackBadgeList && (
        <div className={className}>
          {blackBadgeList.map((label, index) => (
            <Badge key={index} variant="s10_black_white" label={label} isBig />
          ))}
        </div>
      )}
    </>
  );
}
